/**
 * Load and execute a feature module.
 *
 * @param {HTMLElement} el
 * @param {string} selector  - The CSS selector from the registry (e.g. '[data-bolk-anim="fadein"]')
 * @param {() => Promise<module>} importerFn  - Import function injected by the Rollup plugin
 */
export async function load(el, selector, importerFn) {
  try {
    const prefixMatch = selector.match(/\[data-bolk-(\w+)/);
    const prefix = prefixMatch ? prefixMatch[1] : null;

    const rawOptions = {};
    if (prefix) {
      const attrPrefix = `bolk${prefix.charAt(0).toUpperCase() + prefix.slice(1)}`;
      for (const attr of el.attributes) {
        if (attr.name.startsWith(`data-bolk-${prefix}-`)) {
          const key = attr.name.slice(`data-bolk-${prefix}-`.length).replace(/-([a-z])/g, (_, c) => c.toUpperCase());
          rawOptions[key] = attr.value;
        }
      }
    }

    const module = await importerFn();
    const merged = { ...(module.defaults ?? {}), ...rawOptions };
    module.default(el, merged);
  } catch (err) {
    console.warn(`[Bolk] Failed to load feature for "${selector}"`, err);
  }
}
